<template>
  <div :class="{ 'has-error': hasError }" class="col-sm-5">
    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <input-currency v-model="amount" :currency="currency" :decimal-point="decimalPoint" />
    <div
      v-if="shouldCompareWithBalance"
      v-show="balanceDifferentThanRequested"
      id="meta[moneyAmountOther]-error"
      class="help-block m-b-20 f-13 p-5"
    >
      {{
        $t(
          "You're about to request a payout for an amount that is different than your total balance",
        )
      }}
    </div>
    <div
      v-if="shouldCompareWithBalance"
      v-show="balanceLowerThanRequested && !balanceDifferentThanRequested"
      id="meta[moneyAmountOver]-error"
      class="help-block m-b-20 f-13 p-5"
    >
      {{ $t("Your balance doesn't cover this amount") }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoneyAmountInput',
  props: {
    currency: { type: String, required: true },
    decimalPoint: { type: String, default: '.' },
    shouldCompareWithBalance: { type: Boolean, default: false },
    userBalanceInteger: { type: Number, default: 0 },
    userBalanceFraction: { type: Number, default: 0 },
  },
  data() {
    return {
      amount: {
        integer: this.userBalanceInteger ? this.userBalanceInteger : 0,
        fraction: this.userBalanceFraction
          ? this.userBalanceFraction < 10
            ? `0${this.userBalanceFraction}`
            : this.userBalanceFraction
          : '00',
      },
    }
  },
  computed: {
    amountTotal() {
      return Number(this.amount.integer) + this.amount.fraction / 100
    },
    userBalance() {
      return this.userBalanceInteger + this.userBalanceFraction / 100
    },
    balanceDifferentThanRequested() {
      return this.balanceLowerThanRequested
        ? false
        : // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
          this.amountTotal > 0 && this.userBalance != this.amountTotal
    },
    balanceLowerThanRequested() {
      return this.userBalance < this.amountTotal
    },
    hasError() {
      return (
        this.shouldCompareWithBalance &&
        (this.balanceDifferentThanRequested || this.balanceLowerThanRequested)
      )
    },
  },
}
</script>
